export default __webpack_public_path__ + "static/297-5cf1e20ab670aa01c2c0792ea72d8f9d.gif";